import parsePhoneNumber from "libphonenumber-js";
import { z } from "zod";

export function validatePhoneNumber(
  message = "Invalid phone number",
  args?: Parameters<typeof parsePhoneNumber>[1],
) {
  return (arg: string, ctx: z.RefinementCtx) => {
    const phone = parsePhoneNumber(arg, args ?? "US");
    if (phone && phone.isValid()) {
      return phone.number;
    }
    ctx.addIssue({ code: z.ZodIssueCode.custom, message });
    return z.NEVER;
  };
}
